// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__8A5x8","loader-dots":"styles_loader-dots__NGBuY","blink":"styles_blink__AMgOd"};